import { LeftOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Tabs } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useCounterpartServiceGetOtherInstitutionEndpoint } from 'src/api/queries'
import { LegalEntityStatus, Permissions } from 'src/api/requests'
import { LoadingScreen, PageBreadcrumbs } from 'src/components'
import {
  ContractList,
  TemplateContractsList
} from 'src/features/counterParts/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { OtherInstitutionsDetails } from '../components'

export const OtherInstitutionsDetailsPage = () => {
  const { id } = useParams()
  const { t, currentLang } = useLocales()
  const navigate = useNavigate()

  const [form] = Form.useForm()

  const { hasPermission } = useUser()

  const { data, isLoading } = useCounterpartServiceGetOtherInstitutionEndpoint({
    id: String(id)
  })

  const onBackClick = () => {
    navigate(paths.institutions.root)
  }

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        status: data.status === LegalEntityStatus.ACTIVE,
        address: {
          ...data.address,
          region:
            data.address?.cuatmLocality?.parent?.translation?.[
              currentLang?.value
            ],
          regionId: data.address?.cuatmLocality?.parent?.id,
          cuatmLocality:
            data.address?.cuatmLocality?.translation?.[currentLang?.value],
          cuatmLocalityId: data.address?.cuatmLocality?.id
        }
      })
    }
  }, [data])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <PageBreadcrumbs
      title={data?.name}
      items={[
        {
          title: t('menu.other_institutions'),
          path: paths.institutions.root
        },
        {
          title: String(data?.name)
        }
      ]}
      extra={
        <Button
          type="primary"
          onClick={() => navigate(paths.institutions.edit(String(id)))}
        >
          {t('common.edit')}
        </Button>
      }
    >
      <Flex vertical gap={24}>
        <Button
          icon={<LeftOutlined />}
          className="fit-content"
          onClick={onBackClick}
        >
          {t('common.back')}
        </Button>
        <OtherInstitutionsDetails form={form} isDisabled />

        <Tabs
          items={[
            {
              label: t('counterparts.contracts'),
              key: 'contracts',
              children: <ContractList />
            },
            ...(hasPermission(Permissions.TEMPLATES_MENU_VIEW_TEMPLATES)
              ? [
                  {
                    label: t('counterparts.draft'),
                    key: 'draft',
                    children: <TemplateContractsList />
                  }
                ]
              : [])
          ]}
        />
      </Flex>
    </PageBreadcrumbs>
  )
}
